import Image from 'next/image';
export default function Partners() {
  const partners = [[{
    src: '/static/partners/partner-1.png',
    width: 90,
    height: 30
  }, {
    src: '/static/partners/partner-2.png',
    width: 106,
    height: 27
  }], [{
    src: '/static/partners/partner-3.png',
    width: 184,
    height: 25
  }, {
    src: '/static/partners/partner-4.png',
    width: 67,
    height: 12
  }], [{
    src: '/static/partners/partner-5.png',
    width: 60,
    height: 16
  }, {
    src: '/static/partners/partner-6.png',
    width: 60,
    height: 16
  }, {
    src: '/static/partners/partner-7.png',
    width: 41,
    height: 11
  }, {
    src: '/static/partners/partner-8.png',
    width: 83,
    height: 15
  }], [{
    src: '/static/partners/partner-9.png',
    width: 18,
    height: 18
  }, {
    src: '/static/partners/partner-10.png',
    width: 30,
    height: 17
  }, {
    src: '/static/partners/partner-11.png',
    width: 87,
    height: 17
  }, {
    src: '/static/partners/partner-12.png',
    width: 25,
    height: 21
  }, {
    src: '/static/partners/partner-13.png',
    width: 27,
    height: 23
  }]];
  return <div className='mt-14' data-sentry-component="Partners" data-sentry-source-file="Partners.tsx">
      {partners.map((row, rowIndex) => <div key={rowIndex} className='flex justify-center space-x-8 mb-8'>
          {row.map((partner, colIndex) => <div key={colIndex} className='flex items-center justify-center'>
              <Image className='opacity-50' src={partner.src} width={partner.width} height={partner.height} alt={`partner-${rowIndex + 1}-${colIndex + 1}`} />
            </div>)}
        </div>)}
    </div>;
}